
import React from 'react';
import { useStore } from 'contexts/store';
import AliceCarousel from 'react-alice-carousel';
import {Box} from 'components/Box';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useHistory } from 'react-router-dom';
import CAROUSEL from '../../constants/carousel';
import { SET_CURRENT_MOVIE } from '../../constants/store';


const Carousel = ({movies} : {movies:any[]} ) => {
	let { dispatch } = useStore();
  const history = useHistory();

   const goTo = (route: string) => {
        history.push(route);
        window.scrollTo(0, 0);
  };


   const handleClick = (movie: any) : void => {
     dispatch({ type:SET_CURRENT_MOVIE,movie:movie });
     goTo(`/watch/${movie.id}`);
     window.scrollTo(0, 0);
   };
   
   return (
     <AliceCarousel responsive={CAROUSEL} buttonsDisabled={true} mouseTrackingEnabled>
               {movies.map((movie: any) => {
                  return (
                    <Box 
                      adult={movie.adult}
                      backdrop_path={movie.backdrop_path}
                      genre_ids={movie.genre_ids}
                      id={movie.id}
                      original_language={movie.original_language}
                      original_title={movie.original_title}
                      overview={movie.overview}
                      popularity={movie.popularity}
                      poster_path={movie.poster_path}
                      release_date={movie.release_date}
                      title={movie.title}
                      video={movie.video}
                      vote_average={movie.vote_average}
                      vote_count={movie.vote_count}              
                      onClick={() => handleClick(movie)}
                      showRating={true}
                      showTitle={true}
                      size={'small'}
                    />
                  )
               })}
     </AliceCarousel>
    );
};

export default Carousel; 